<template>
    <a-popover title="设置播放速度">
        <template slot="content">
            <a-radio-group
                :options="options"
                @change="onChangeRate"
                v-model="currentRate" />
        </template>
        <div class="rate-label">
            {{ currentRate }}倍速
        </div>
    </a-popover>
</template>

<script>
 import Vue from 'vue';
 import Button from "ant-design-vue/lib/button";
 import Popover from "ant-design-vue/lib/popover";
 import Radio from "ant-design-vue/lib/radio/Radio";
 import RadioGroup from "ant-design-vue/lib/radio/Group";

 Vue.component(Button.name, Button);
 Vue.component(Popover.name, Popover);
 Vue.component(Radio.name, Radio);
 Vue.component(RadioGroup.name, RadioGroup);

 export default {
     name: 'RateButton',
     data() {
         return {
             options: []
         }
     },
     props: {
     },
     computed: {
         currentRate: {
             get() { return this.$store.getters.playerCurrentRate },
             set(value) { this.$store.commit('playerChangeRate', value ) }
         },
     },
     components: {
     },
     created() {
         console.log("Create RateButton")
     },
     mounted() {
         console.log("Mount RateButton")

         this.options = this.$store.getters.playerRateOptions
     },
     methods: {
         onChangeRate(e) {
             this.$store.commit("playerChangeRate", e.target.value)
         },
     }
 }
</script>

<style scoped>
 .rate-label {
     color: #AAA;
     width: 60px;
     text-align: center;
 }
</style>
